import { defineStepper, type Stepper } from '@stepperize/react';
import type { AwardedNominationRole } from '../../models/shared/winner-role-types';
import {
  questionnaireContactValidationSchema,
  questionnaireEventAttendeesValidationSchema,
  questionnaireMediaValidationSchema,
} from '../../models/schemas/questionnaire-wizard-validation.schema';

export const questionnaireStepper = defineStepper([
  { id: 'contact', title: 'Contact information', schema: questionnaireContactValidationSchema },
  { id: 'event-attendees', title: 'Event attendees', schema: questionnaireEventAttendeesValidationSchema },
  { id: 'logo', title: 'Upload logo' },
  { id: 'media', title: 'Upload media', schema: questionnaireMediaValidationSchema },
]);

export type QuestionnaireStepId = (typeof questionnaireStepper.steps)[number]['id'];

export type QuestionnaireStepperInstance = Stepper<typeof questionnaireStepper.steps>;

export const getVisibleQuestionnaireStepIds = (
  hasWinnerEvents: boolean,
  winnerRole?: AwardedNominationRole,
): QuestionnaireStepId[] => {
  if (winnerRole === 'Finalist') {
    return ['contact'];
  }

  return hasWinnerEvents
    ? ['contact', 'event-attendees', 'logo', 'media']
    : ['contact', 'logo', 'media'];
};
